import { Magazine } from "./Datatypes";
import { editionsFindAllByMagazine, getInfo } from "./FetchFromAPI";
import { usePersistBoundStore } from "./zustand/Store";


function formatDateToYYYYMMDD(dateString: string): string {
    //console.log(dateString)
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');

    return `${year}${month}${day}`;
}


export const useFetchLiveMagazines = () => {
    return async (): Promise<Magazine[]> => {
        let magazines: Magazine[] = [];
        const fetchMagazines = await getInfo();
        const parsedFetchedMagazines = JSON.parse(fetchMagazines);
        //console.log("fetchMagazines - fetchMagazines: ",JSON.stringify(JSON.parse(fetchMagazines), null, 2));

        for (const m of parsedFetchedMagazines) {
            //console.log("for Loop m");
            const fetchEditions = await editionsFindAllByMagazine(m.id);
            const parsedFetchedEditions = JSON.parse(fetchEditions);
            //console.log("fetchMagazines - fetchEditions: ", JSON.stringify(JSON.parse(fetchEditions), null, 2));

            for (const e of parsedFetchedEditions) {
                //console.log("for Loop e ", e);
                //console.log("fetchMagazines - edition of fethedEditions: ", JSON.stringify(JSON.parse(e), null, 2));
                //const parsed = JSON.parse(e);
                magazines.push({
                    date: formatDateToYYYYMMDD(m.publicationDate),
                    edition: e.edition,
                    api_id: m.id,
                });
                
            }
        }

        magazines.sort((a, b) => b.date.localeCompare(a.date));
        return magazines;
    };
};
export const useFetchArchiveMagazines = () => {
    const getAllStoredEpapers = usePersistBoundStore((state) => state.getAllStoredEpapers);

    return (): Magazine[] => {
        const storedMagazines = getAllStoredEpapers();
        storedMagazines.sort((a, b) => b.date.localeCompare(a.date));
        //console.log("useFetchArchiveMagazines - magazines ", storedMagazines);
        return storedMagazines;
    };
};

export const useFetchMagazineInfo = () => {
    const getAllStoredEpapers = usePersistBoundStore((state) => state.getAllStoredEpapers);

    return (): Magazine[] => {
        const storedMagazines = getAllStoredEpapers();
        storedMagazines.sort((a, b) => b.date.localeCompare(a.date));
        //console.log("useFetchArchiveMagazines - magazines ", storedMagazines);
        return storedMagazines;
    };
};